export const screenIds = {
  START: 'START',
  MAIN: 'MAIN',
  GAME: 'GAME',
};

export const difficulties = {
  EASY: 'EASY',
  MEDIUM: 'MEDIUM',
  HARD: 'HARD',
};



// WEBPACK FOOTER //
// ./src/app/enums/general.js